module.exports = __webpack_public_path__ + "static/media/new-message.16c5dc6d.png";